import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import { motion } from 'framer-motion';

// Trusted by logos (your existing array)
const TrustedBy = [
  { image: "./images/chosen/1.png" },

  { image: "./images/chosen/2.png" },

  { image: "./images/chosen/3.png" },

  { image: "./images/chosen/4.png" },

  { image: "./images/chosen/5.png" },

  { image: "./images/chosen/6.png" },

  { image: "./images/chosen/7.png" },

  { image: "./images/chosen/8.png" },

  { image: "./images/chosen/9.png" },

  { image: "./images/chosen/10.png" },

  { image: "./images/chosen/11.png" },

  { image: "./images/chosen/12.png" },

  { image: "./images/chosen/13.png" },

  { image: "./images/chosen/14.png" },

  { image: "./images/chosen/15.png" },

  { image: "./images/chosen/16.png" },

  { image: "./images/chosen/17.png" },

  { image: "./images/chosen/18.png" },

  { image: "./images/chosen/19.png" },

  { image: "./images/chosen/20.png" },

  { image: "./images/chosen/21.png" },

  { image: "./images/chosen/22.png" },

  { image: "./images/chosen/23.png" },

  { image: "./images/chosen/24.png" },

  { image: "./images/chosen/25.png" },

  { image: "./images/chosen/26.png" },

  { image: "./images/chosen/27.png" },

  { image: "./images/chosen/28.png" },

  { image: "./images/chosen/29.png" },

  { image: "./images/chosen/30.png" },

  { image: "./images/chosen/31.png" },

  { image: "./images/chosen/32.png" },

  { image: "./images/chosen/33.png" },

  { image: "./images/chosen/34.png" },

  { image: "./images/chosen/35.png" },

  { image: "./images/chosen/36.png" },

  { image: "./images/chosen/37.png" },

  { image: "./images/chosen/38.png" },

  { image: "./images/chosen/39.png" },

  { image: "./images/chosen/40.png" },

  { image: "./images/chosen/41.png" },

  { image: "./images/chosen/42.png" },

  { image: "./images/chosen/43.png" },

  { image: "./images/chosen/44.png" },

  { image: "./images/chosen/45.png" },

  { image: "./images/chosen/46.png" },

  { image: "./images/chosen/47.png" },

  { image: "./images/chosen/48.png" },

  { image: "./images/chosen/49.png" },

  { image: "./images/chosen/50.png" },

  { image: "./images/chosen/51.png" },

  { image: "./images/chosen/52.png" },

  { image: "./images/chosen/53.png" },

  { image: "./images/chosen/54.png" },

  { image: "./images/chosen/55.png" },

  { image: "./images/chosen/56.png" },

  { image: "./images/chosen/57.png" },

  { image: "./images/chosen/58.png" },

  { image: "./images/chosen/59.png" },

  { image: "./images/chosen/60.png" },

  { image: "./images/chosen/61.png" },

  { image: "./images/chosen/62.png" },

  { image: "./images/chosen/63.png" },

  { image: "./images/chosen/64.png" },

  { image: "./images/chosen/65.png" },

  { image: "./images/chosen/66.png" },

  { image: "./images/chosen/67.png" },

  { image: "./images/chosen/68.png" },

  { image: "./images/chosen/69.png" },

  { image: "./images/chosen/70.png" },

  { image: "./images/chosen/71.png" },

  { image: "./images/chosen/72.png" },

  { image: "./images/chosen/73.png" },

  { image: "./images/chosen/74.png" },

  { image: "./images/chosen/75.png" },

  { image: "./images/chosen/76.png" },

  { image: "./images/chosen/77.png" },

  { image: "./images/chosen/78.png" },

  { image: "./images/chosen/79.png" },

  { image: "./images/chosen/80.png" },

  { image: "./images/chosen/81.png" },

  { image: "./images/chosen/82.png" },
];

export default function TrustedBySection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="flap-trusted min-h-[400px] bg-[#06112b] relative overflow-hidden">
      {/* Inline styles – same as Testimonial.js */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
        @import url('https://api.fontshare.com/v2/css?f[]=clash-display@400,500,600,700&display=swap');

        .flap-trusted {
          padding: 100px 5%;
          position: relative;
          font-family: 'DM Sans', sans-serif;
        }

        .flap-trusted::before {
          content: '';
          position: absolute; inset: 0;
          background-image:
            linear-gradient(rgba(28,115,186,0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(28,115,186,0.05) 1px, transparent 1px);
          background-size: 52px 52px;
          pointer-events: none;
        }

        .flap-trusted::after {
          content: '';
          position: absolute;
          width: 600px; height: 600px;
          background: radial-gradient(circle, rgba(28,115,186,0.15) 0%, transparent 70%);
          top: -150px; right: -150px;
          pointer-events: none;
          z-index: 0;
        }

        .flap-trusted-inner {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .trusted-label {
          display: block;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: #f5a623;
          margin-bottom: 16px;
          text-align: center;
        }

        .trusted-heading {
          font-family: 'Clash Display', sans-serif;
          font-size: clamp(2.2rem, 5vw, 3.8rem);
          font-weight: 700;
          text-align: center;
          line-height: 1.15;
          margin-bottom: 60px;
          color: #06112b;
        }

        .trusted-heading span {
          color: #1c73ba;
        }

        .trusted-swiper-wrap {
          margin: 0 -5%;
          padding: 0 5% 40px;
          overflow: hidden;
        }

        .trusted-swiper-wrap .swiper { overflow: visible !important; }

        .trusted-logo-card {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 20px;
          padding: 24px 32px;
          backdrop-filter: blur(12px);
          transition: all 0.4s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 120px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        }

        .trusted-logo-card:hover {
          border-color: rgba(28,115,186,0.35);
          transform: translateY(-8px);
          box-shadow: 0 12px 32px rgba(0,0,0,0.25);
        }

        .trusted-logo {
          max-height: 80px;
          max-width: 100%;
          object-fit: contain;
          filter: grayscale(0.4) brightness(1.1);
          transition: all 0.4s ease;
        }

        .trusted-logo-card:hover .trusted-logo {
          filter: grayscale(0) brightness(1);
        }

        .swiper-slide-active .trusted-logo-card {
          border-color: rgba(28,115,186,0.4);
          background: rgba(28,115,186,0.08);
          transform: translateY(-8px);
        }

        @media (max-width: 640px) {
          .trusted-logo-card { padding: 20px; min-height: 100px; }
          .trusted-logo { max-height: 60px; }
        }
      `}</style>

      <div className="flap-trusted-inner">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <span className="trusted-label">Trusted By</span>
          <h2 className="trusted-heading">
            Chosen <span>By</span> Industry Leaders
          </h2>
        </motion.div>

        <div className="trusted-swiper-wrap">
          <Swiper
            modules={[Autoplay, FreeMode]}
            autoplay={{
              delay: 100,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={3000}
            freeMode={{
              enabled: true,
              momentum: true,
              sticky: true,
            }}
            loop={true}
            slidesPerView={1.2}
            spaceBetween={20}
            centeredSlides={true}
            breakpoints={{
              640: { slidesPerView: 3, spaceBetween: 30, centeredSlides: false },
              1024: { slidesPerView: 6, spaceBetween: 40, centeredSlides: false },
            }}
            className="!overflow-visible"
          >
            {TrustedBy.map((client, index) => (
              <SwiperSlide key={index}>
                <motion.div
                  whileHover={{ scale: 1.08, transition: { duration: 0.4 } }}
                  className="trusted-logo-card"
                >
                  <img
                    className="trusted-logo"
                    src={client.image}
                    alt={`Trusted client ${index + 1}`}
                    loading="lazy"
                  />
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}